import React, { useContext } from 'react';
import Breadcrumb from '../shared/Breadcrumb';
import SideNav from '../patient/shared/SideNav';
import { AuthContext } from '../../contexts/AuthContext';
import ChangePassword from './ChangePassword';

const PatChangePassword = () => {
    const { userState } = useContext(AuthContext);
    const patient = userState.loggedInUser;
   
    return ( 
        <div>
            <Breadcrumb title ='Change Password'/>
            <div className="content">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                           <SideNav applyCssFor='changepassword' user={patient} />
						</div>
                        <div className="col-md-7 col-lg-8 col-xl-9">
                            <ChangePassword />
						</div>
					</div>
				</div>

			</div>		
			
        </div>
    );
}
 
export default PatChangePassword;